<span>{{formattedPhoneNumber}}</span>
